import { render, staticRenderFns } from "./DeviceGroup.vue?vue&type=template&id=08fae12a"
import script from "./DeviceGroup.vue?vue&type=script&lang=js"
export * from "./DeviceGroup.vue?vue&type=script&lang=js"
import style0 from "./DeviceGroup.vue?vue&type=style&index=0&id=08fae12a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports